import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
import { FilterInputComponent } from './filter-input/filter-input.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DatePickerComponent } from "../../../shared/components/input/date-picker/date-picker.component";
import { DateRangeComponent } from "../../../shared/components/input/date-range/date-range.component";

@NgModule({
	declarations: [FilterBarComponent, FilterInputComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatSlideToggleModule,
        DatePickerComponent,
        DateRangeComponent
    ],
	providers: [],
	exports: [FilterBarComponent, FilterInputComponent]
})
export class FilterModule {}
